export const setIsWebViewVisible = (isVisible: boolean) => {
  if (isVisible) {
    document.body.classList.remove('hide-root');
    document.body.classList.remove('no-background');
  } else {
    document.body.classList.add('hide-root');
    document.body.classList.add('no-background');
  }
};
